import { InputSize } from '../forms/fields'

// Settings scoped to encounter forms. Future encounter-form settings go here.
export interface EncounterFormSettings {
  inputSize?: InputSize
}

// charting-form-settings/{userId} doc. Namespaced per form domain so future charting
// surfaces (labor charting, visits, …) can add their own keys without colliding —
// mirrors how UserSettings groups by feature.
export interface ChartingFormSettings {
  encounterForms?: EncounterFormSettings
}

export const DEFAULT_ENCOUNTER_INPUT_SIZE: InputSize = 'sm'
